import { createError } from '@adv-frontend/error';

import { getFormStoreSingleton } from '../../store/store';
import { $canSetWhileSubmitting, SetValueOptions } from '../../fields/types';

/** Ошибка, которая происходит если попытаться изменить значение формы, которая в данный момент отправляется */
export const FormIsSubmittingError = createError<{
    formName: string;
    formId: string;
    fieldId?: string;
}>('FormIsSubmittingError');

/** Выбрасывает исключение, если форма в данный момент отправляется */
export function assertFormNotSubmitting(
    message: string,
    params: { formName: string; formId: string; formInitializationId: string },
    fieldId?: string,
    options?: SetValueOptions
) {
    const { getFormState } = getFormStoreSingleton(params.formName);
    const formState = getFormState({ formInitializationId: params.formInitializationId });

    // Не выбрасываем исключение, если мы дожидаемся завершения начавшихся экшенов
    const canWaitForAsyncActions = formState?.isAwaitingStartedAsyncSetters && options?.[$canSetWhileSubmitting];

    if (formState?.isSubmitting && !canWaitForAsyncActions) {
        throw new FormIsSubmittingError(message, {
            cause: null,
            additional: {
                formName: params.formName,
                formId: params.formId,
                fieldId,
            },
        });
    }
}
